const initialState = {
    error: null,
    configuredActiveWalletAccountLoaded: false,
    multipleWalletAccountsEnabledLoaded: false,
    walletAccountsDataLoaded: false,
    loaded: false,
    data: Object.create(null),
    multipleWalletAccountsEnabled: undefined,
    configuredActiveWalletAccount: null,
};
export default initialState;
